import React, { FC } from 'react';
import { useApplication } from '../../../../../../context/ApplicationContext';

import Schema from '../../../../../../lib/paths/mittelabruf_FULL_Paths.json';
import { Box, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
const P = Schema.attributes;

const Ueberpruefung: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<Typography variant="h3">Überprüfung Ihrer Daten</Typography>
			<Typography sx={{ mt: '1rem' }}>Bitte überprüfen Sie die von Ihnen bereits gemachten Angaben</Typography>
			<Box sx={{ mt: '1rem' }}>
				<Grid2 container spacing={6}>
					<Grid2 sm={6}>
						<Typography>Organisation</Typography>
						<CreateForm
							formStruc={OrgaDetails()}
							formValues={application}
							updateFormValuesFunc={setApplicationProperty}
							readOnly={readOnly}
						/>
					</Grid2>
					<Grid2 sm={6}>
						<Typography>Zu überweisen auf folgende Bankverbindung</Typography>
						<CreateForm
							formStruc={strucBankDaten()}
							formValues={application}
							updateFormValuesFunc={setApplicationProperty}
							readOnly={readOnly}
						/>
					</Grid2>
				</Grid2>
			</Box>
		</>
	);
};
export default Ueberpruefung;

export const strucBankDaten = () => {
	return [
		{
			fields: [P.Bankverbindung_Institut, P.Bankverbindung_IBAN, P.Bankverbindung_Verwendungszweck],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};

export const OrgaDetails = () => {
	return [
		{
			fields: [
				{
					...P.Zuwendungsantrag.schema.attributes.Antragstellerin_Name,
					disabled: true,
				},
				{
					...P.Zuwendungsantrag.schema.attributes.Antragstellerin_Rechtsform,
					disabled: true,
				},
				{
					...P.Zuwendungsantrag.schema.attributes.Antragstellerin_Strasse_Hausnummer,
					disabled: true,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [
				{
					...P.Zuwendungsantrag.schema.attributes.Antragstellerin_PLZ,
					disabled: true,
				},
				{
					...P.Zuwendungsantrag.schema.attributes.Antragstellerin_Ort,
					disabled: true,
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
};
